import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { environment } from '../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
// import { of } from 'rxjs';
// import { ApplicationQuestionsDTO } from '../DTOs/Organisations/Models/ApplicationQuestionsDTO';
// import { SurveyNameDTO } from '../DTOs/Comms/Models/SurveyNameDTO';
// import { EmailTemplateDTO } from '../DTOs/Comms/Models/EmailTemplateDTO';
import { AppConfigService, AppConfig } from './app-config.service';
import { TextRequestMessage } from '../DTOs/Comms/Models/TextRequestMessage';
import { EmailRequestMessage } from '../DTOs/Comms/Models/EmailRequestMessage';
import { AuthService } from '../auth/auth.service';
import { SurveyDTO } from 'src/DTOs/PatientProcedures/Models/SurveyDTO';
import { tap, combineLatest, shareReplay, map } from 'rxjs/operators';
import { EmailTemplateDTO } from 'src/DTOs/Comms/Models/EmailTemplateDTO';

// this multi-language stuff is copied from @followapp/common to avoid upgrading this project to Angular 12 and typescript ^3.4
interface MultiLanguageData<Tdata> {
  "en-GB": Tdata;
  "en-US": Tdata;
  "en-AU": Tdata;
  "es-ES": Tdata;
  "it-IT": Tdata;
  "pl-PL": Tdata;
  "pt-PT": Tdata;
  __fixedUp?: boolean;
  __optional?: boolean;
}
function closestLanguageValue<T>(object: MultiLanguageData<T>, locale: string): T {
  if (isSupportedLanguage(locale)) {
      return object[locale];
    }
    else {
      const language = SupportedLanguageCollection.filter(x => x.startsWith(locale))[0] as SupportedLanguages
                        || SupportedLanguageCollection.filter(x => x.length > 1 && locale.length > 1 && x.slice(0, 2) == locale.slice(0, 2))[0] as SupportedLanguages
                        || "en-GB";
      return object[language] || object["en-GB"]; // fall back to en-GB if a value is null - if it's meant to be null then en-GB will be too!
    }
}
type AnyMultiLanguageData = MultiLanguageData<any>;
type SupportedLanguages = "en-GB"|"en-US"|"en-AU"|"es-ES"|"it-IT"|"pl-PL"|"pt-PT";
const SupportedLanguageCollection = ["en-GB","en-US","en-AU","es-ES","it-IT","pl-PL","pt-PT"];
const minimumSupportedLanguageCollection = ["en-GB"];
function isSupportedLanguage(s: string | SupportedLanguages): s is SupportedLanguages {
  return SupportedLanguageCollection.some(x => x === s);
}
function isMuiltiLanguage(s: any): s is AnyMultiLanguageData {
  return typeof s === "object" && s !== null && minimumSupportedLanguageCollection.every(x => x in s);
}

export interface SurveyStub {
  name: string;
  id: string;
  questions: QuestionStub[];
}

export interface QuestionStub {
  questionText: string;
  replyType: string;
}

@Injectable()
export class SurveyService {

  public appConfig: AppConfig = new AppConfig();

  constructor(private http: HttpClient,
              @Inject(LOCALE_ID) private locale: string,
              private appConfigService: AppConfigService) {

    this.appConfig = this.appConfigService.getConfig();
  }

  GetSurveyQuestionStubs(orgId: string): Observable<SurveyStub[]> {
    return this.http
             .get<SurveyStub[]>(`${this.appConfig.survey_service_api_url}definitions/questions/stubs/${orgId}?includeGlobal=true`)
             .pipe(map(x => {
                x.forEach(s => {
                  if (isMuiltiLanguage(s.name)) s.name = closestLanguageValue(s.name, this.locale);
                  s.questions.forEach(q => {
                    if (isMuiltiLanguage(q.questionText)) q.questionText = closestLanguageValue(q.questionText, this.locale);
                  });
                });
                return x;
             }));
  }

  GetSurveyQuestionStub(surveyId: string, orgId: string): Observable<SurveyStub> {
    return this.http
             .get<SurveyStub>(`${this.appConfig.survey_service_api_url}definitions/questions/stubs/${orgId}/${surveyId}?includeGlobal=true`)
             .pipe(map(s => {
                if (isMuiltiLanguage(s.name)) s.name = closestLanguageValue(s.name, this.locale);
                s.questions.forEach(q => {
                  if (isMuiltiLanguage(q.questionText)) q.questionText = closestLanguageValue(q.questionText, this.locale);
                });
                return s;
             }));
  }
}
